export default (function () {
  $(window).scroll(function () {
    var sticky = $('.new-review-tabs__form-header'),
        scroll = $(window).scrollTop();
    if (scroll >= $("header").outerHeight()) sticky.addClass('fixed');else sticky.removeClass('fixed');
  });
});